module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_3_1.33010e00.jpeg";